// Lista de especialidades médicas usada en el registro de doctores,
// el perfil, el encabezado del dashboard y la receta médica.
export const MEDICAL_SPECIALTIES = [
  "Medicina General",
  "Medicina Familiar",
  "Medicina Interna",
  "Pediatría",
  "Ginecología y Obstetricia",
  "Cardiología",
  "Dermatología",
  "Endocrinología",
  "Gastroenterología",
  "Hematología",
  "Nefrología",
  "Neumología",
  "Neurología",
  "Oftalmología",
  "Oncología",
  "Ortopedia y Traumatología",
  "Otorrinolaringología",
  "Psiquiatría",
  "Radiología",
  "Reumatología",
  "Urología",
  "Cirugía General",
  "Anestesiología",
  "Odontología",
  "Nutrición",
  "Psicología",
  "Geriatría",
  "Infectología",
  "Medicina del Deporte",
  "Medicina Estética",
  "Otra",
];
